/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Lernkaskadeaufenthalt1Inputs */

const de__field_lernkaskadeaufenthalt1 = /** @type {(inputs: _Field_Lernkaskadeaufenthalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LKK Aufenthalt`)
};

/**

* @param {_Field_Lernkaskadeaufenthalt1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_lernkaskadeaufenthalt1 = /** @type {((inputs?: _Field_Lernkaskadeaufenthalt1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Lernkaskadeaufenthalt1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_lernkaskadeaufenthalt1(inputs)
});
export { _field_lernkaskadeaufenthalt1 as "_field_lernkaskadeAufenthalt" }